import Ev from '../../../lib/event';

var evs = [
    'prevStep',
    'nextStep',
    'changeStep',
    'saveJob',
    'browseImages',
    'selectCategory',
    'closeImageModal',
    'selectImage',
    'fieldChange',
    'changeText',
    'phoneChange',
    'changeBackgroundColor',
    'uploadImage',
    'confirmBilling'
].reduce(function (acc, type) {
    acc[type] = Ev(type);
    return acc;
}, {})

export default evs;
